import {useEffect} from "react";
import NavbarLast from '../../layouts/Head/NavbarLast'
import CardForm from './CardForm'
import {handelTitle} from '../../utils'
//import {Breadcrumb} from "react-bootstrap";
import Breadcrumb from '../../components/Breadcrumb'
import { useI18n } from '../../i18n/context'

const ContactContainer = () => {
  const { t } = useI18n();

  useEffect(() => {
    handelTitle(t('containers.contact.title'))
  },[])

  return (
    <>
      <Breadcrumb text1={t('containers.contact.breadcrumb')} text2={null}/>
      <main className="main-content" style={{ paddingTop: '8px' }}>
        <div className="container-fluid collections-container">
          <div className="col-12 py-0">
            <div className="pixel-card mt-2" style={{ borderRadius: '12px' }}>
              <div className="card-header text-center pt-4">
                <h5 className="text-white mb-0">{t('containers.contact.heading')}</h5>
                <p className="text-lead text-secondary mb-0">{t('containers.contact.subtitle')}</p>
              </div>
              <CardForm />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default ContactContainer;
